import * as React from "react";
function SvgMenu(props, svgRef) {
  return <svg width={20} height={16} xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><rect width={20} height={2} rx={1} /><rect y={7} width={20} height={2} rx={1} /><rect y={14} width={20} height={2} rx={1} /></svg>;
}
const ForwardRef = React.forwardRef(SvgMenu);
export default ForwardRef;